<div class="row row-cols-1 row-cols-lg-3 g-4 justify-content-center">
  <app-plan-card
    class="col order-3 order-lg-1"
    variant="base"
    [title]="page.basePlan.title"
    [subtitle]="basePlanSubtitle"
    [price]="plan1YearlyPrice"
    [features]="page.basePlan.features"
    ctaText="Choose {{ page.basePlan.title }}"
    (selectPlan)="selectBase()"
  ></app-plan-card>

  <app-plan-card
    class="col order-2"
    variant="alert"
    [elevated]="true"
    [title]="page.alertPlan.title"
    [subtitle]="alertPlanSubtitle"
    [price]="plan2YearlyPrice"
    [inheritedLabel]="'Everything in ' + page.basePlan.title"
    [features]="page.alertPlan.features"
    ctaText="Choose {{ page.alertPlan.title }}"
    (selectPlan)="selectAlert()"
  ></app-plan-card>

  <app-plan-card
    *ngIf="isIdentiSmartTagPlanAvailable"
    class="col order-1 order-lg-3"
    variant="locator"
    [title]="page.locatorPlan.title"
    [subtitle]="locatorPlanSubtitle"
    [price]="plan3YearlyPrice"
    [originalPrice]="plan3YearlyPriceOriginal"
    [badgeText]="page.locatorPlan.badgeText"
    [iconSrc]="page.locatorPlan.iconSrc"
    [colorOptions]="page.locatorPlan.colorOptions"
    [inheritedLabel]="'Everything in ' + page.alertPlan.title"
    [features]="page.locatorPlan.features"
    ctaText="Choose {{ page.locatorPlan.title }}"
    (selectPlan)="selectLocator()"
  ></app-plan-card>
</div>
